export const TypTitle = {
    fontSize: "15px",
    flex: 1, 
    minWidth: 0,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
}

export const CardMediaStyle = {
    /** Квадрат по ширине full-bleed; без height: 100% — иначе в flex-карточке высота схлопывается. */
    width: "calc(100% + 24px)",
    mx: "-12px",
    aspectRatio: '1 / 1',
    height: 'auto',
    objectFit: "cover",
    flexShrink: 0,
    marginBottom: 1,
}

export const TypDescription = {
    fontSize: "15px",

    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    overflowWrap: 'anywhere',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    WebkitLineClamp: 2,
}
